"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _Autocomplete2 = _interopRequireDefault(require("@material-ui/lab/Autocomplete"));

var _TextField2 = _interopRequireDefault(require("@material-ui/core/TextField"));

var _ArrowDropDownRounded2 = _interopRequireDefault(require("@material-ui/icons/ArrowDropDownRounded"));

var _AccessTime2 = _interopRequireDefault(require("@material-ui/icons/AccessTime"));

var _styles = require("@material-ui/core/styles");

var _react = _interopRequireDefault(require("react"));

var _Switch = _interopRequireDefault(require("../../components/Switch"));

var _propTypes = require("../../propTypes");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var useStyles = (0, _styles.makeStyles)(function () {
  return {
    formControl: {
      marginTop: "0.25rem",
      width: "70%"
    }
  };
});
var timeOptions = [{
  label: "12 hours",
  value: 12
}, {
  label: "24 hours",
  value: 24
}];

var DateType = function DateType(_ref) {
  var _ref$options = _ref.options,
      options = _ref$options === void 0 ? {} : _ref$options,
      setOptions = _ref.setOptions;
  var classes = useStyles();

  var handleIncludeTime = function handleIncludeTime(e) {
    var checked = e.target.checked;
    setOptions(_objectSpread(_objectSpread({}, options), {}, {
      includeTimeField: checked
    }));
  };

  var handleTimeFormat = function handleTimeFormat(e, item) {
    setOptions(_objectSpread(_objectSpread({}, options), {}, {
      timeFormat: Number(item.value)
    }));
  };

  return /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      paddingRight: "1rem",
      fontSize: "0.875rem",
      marginTop: "0.25rem",
      color: "rgba(156, 163, 175, 1)"
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      display: "flex",
      marginTop: "0.5rem",
      alignItems: "center"
    }
  }, /*#__PURE__*/_react["default"].createElement(_Switch["default"], {
    checked: Boolean(options === null || options === void 0 ? void 0 : options.includeTimeField),
    onChange: handleIncludeTime
  }), /*#__PURE__*/_react["default"].createElement(_AccessTime2["default"], {
    style: {
      marginLeft: "0.5rem",
      fontSize: "1rem",
      color: "rgba(31, 41, 55, 1)"
    }
  }), /*#__PURE__*/_react["default"].createElement("span", {
    style: {
      marginLeft: "0.25rem"
    }
  }, "Include a time field")), (options === null || options === void 0 ? void 0 : options.includeTimeField) && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      marginTop: "0.75rem",
      color: "rgba(75, 85, 99, 1)"
    }
  }, "Time format"), /*#__PURE__*/_react["default"].createElement(_Autocomplete2["default"], {
    size: "small",
    onChange: handleTimeFormat,
    options: timeOptions,
    value: options !== null && options !== void 0 && options.timeFormat ? timeOptions.find(function (item) {
      return item.value === (options === null || options === void 0 ? void 0 : options.timeFormat);
    }) : timeOptions[0],
    getOptionLabel: function getOptionLabel(option) {
      return option.label;
    },
    openOnFocus: true,
    blurOnSelect: true,
    disableClearable: true,
    popupIcon: /*#__PURE__*/_react["default"].createElement(_ArrowDropDownRounded2["default"], null),
    renderInput: function renderInput(params) {
      return /*#__PURE__*/_react["default"].createElement(_TextField2["default"], _extends({}, params, {
        placeholder: "Select time",
        variant: "outlined",
        size: "small"
      }));
    }
  })));
};

DateType.propTypes = _propTypes.OptionProps;
var _default = DateType;
exports["default"] = _default;